module.exports = __webpack_public_path__ + "media/images/flags/bq-8ff78ac28371e9069bfb5206d9704c9a.svg";